import PropTypes from "prop-types";
import React from "react";

const DealDayRenderer = ({ props, dealData }) => {

  let timeStyle = {
    fontSize: dealData.timeFontSize > 0 ? dealData.timeFontSize + 'px' : "", fontFamily: dealData.timeFont,
    color: dealData?.timeColor ? dealData.timeColor : ""
  }
  let dayStyle = {
    fontFamily: dealData.timeFont,
    color: dealData.timeColor
  }
  return (
    <>
      <div className="antera-countdown-container timer timer-style">
        <div>
          <span className="antera-countdown-text-day cdown day" style={timeStyle}>
            {props.days} <p style={dayStyle}>Days</p>
          </span>
          <span className="antera-countdown-text-hours cdown hour" style={timeStyle}>
            {props.hours} <p style={dayStyle}>Hours</p>
          </span>
          <span className="antera-countdown-text-minutes cdown minutes" style={timeStyle}>
            {props.minutes} <p style={dayStyle}>Minutes</p>
          </span>
          <span className="antera-countdown-text-seconds" style={timeStyle}>
            {props.seconds} <p style={dayStyle}>Secs</p>
          </span>
        </div>
      </div>
    </>
  );
};

DealDayRenderer.propTypes = {
  days: PropTypes.number,
  hours: PropTypes.number,
  minutes: PropTypes.number,
  seconds: PropTypes.number,
  props: PropTypes.object
};

export default DealDayRenderer;
